import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../../contexts/Web3StatusContext";
import TransactionStatus from '../../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class ExcludeFrom extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    address: '',
    stackId: -1,
  };

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFOREST, GAMEFORESTSale } = drizzle.contracts;

    const stackId = GAMEFOREST.methods[this.props.methodName].cacheSend
        (this.state.address);
    this.setState({ stackId: stackId });
  }

  myAddressChangeHandler = (event) => {
    let { value } = event.target;
    const address = value;
    this.setState({address: address});
  }

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    var disabled = this.context.activeAccount == null;

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        Address:{" "}
        <input
          value={this.state.address}
          onChange={this.myAddressChangeHandler}
        />
        <br/>
        <input
        type='submit'
        value="Exclude"
        disabled={disabled}
        />
        <br/>
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default ExcludeFrom;
